import React from "react"
import classnames from "classnames"
import styles from "./Tag.less"
import CheckIcon from "../Icons/CheckIcon"

class Tag extends React.PureComponent {
  render() {
    const { children, color = "green", checked = false } = this.props
    return (
      <div
        className={classnames({
          [styles.Tag]: true,
          [styles.TagGreen]: color === "green",
          [styles.TagRed]: color === "red",
          [styles.TagOrange]: color === "orange",
          [styles.TagBlue]: color === "blue",
          [styles.TagGrey]: color === "grey"
        })}>
        {checked &&
          <CheckIcon style={{
            width: "10px",
            height: "9px",
            paddingRight: ".5em"
          }} />
        }
        {children}
      </div>
    )
  }
}


export default Tag



// WEBPACK FOOTER //
// ./src/AtomicComponents/Tag/Tag.jsx